import {
  useMfaSmsList,
  useScreen,
  useUser,
} from '@auth0/auth0-acul-react/mfa-sms-list';

export const useMfaSmsListManager = () => {
  const mfaSmsList = useMfaSmsList();
  const screen = useScreen();
  const user = useUser();

  const { texts } = screen ?? {};
  const enrolledPhoneNumbers = user?.enrolledPhoneNumbers ?? [];

  const handleSelectPhoneNumber = async (index: number): Promise<void> => {
    await mfaSmsList.selectPhoneNumber({ index });
  };

  const handleBackAction = async (): Promise<void> => {
    await mfaSmsList.backAction({});
  };

  return {
    mfaSmsList,
    handleSelectPhoneNumber,
    handleBackAction,
    texts: texts ?? {},
    enrolledPhoneNumbers,
  };
};
